import { render, staticRenderFns } from "./Acheteurs.vue?vue&type=template&id=03b64056&"
import script from "./Acheteurs.vue?vue&type=script&lang=js&"
export * from "./Acheteurs.vue?vue&type=script&lang=js&"
import style0 from "./Acheteurs.vue?vue&type=style&index=0&id=03b64056&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports